import { ReplaceMeSelectionType } from '@/shared/constants/replaceMe/ReplaceMeSelectionType'
import i18n from '@plugins/vue-i18n'

/**
 * Simple helper that returns the localised text for the selected day
 * @param {String} selectedDay Value of ReplaceMeSelectionType enum
 * @param {Boolean} isNextDayMonday Affects returned string if next day is monday
 * @return Locaised selected day text
 */
export default (selectedDay, isNextDayMonday = false) => {
  let dayText = i18n.t('replaceMe.todayLabel')

  if (selectedDay === ReplaceMeSelectionType.TOMORROW) {
    dayText = isNextDayMonday
      ? i18n.t('replaceMe.nextMondayLabel')
      : i18n.t('replaceMe.tomorrowLabel')
  }
  return dayText
}
